var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    fillRule: "evenodd",
    d: "M4.133 12.087C5.74 6.086 11.91 2.524 17.91 4.132a11.202 11.202 0 0 1 5.045 2.911l2.375 2.376V5.444a.937.937 0 1 1 1.875 0v6.24c0 .518-.42.938-.937.938h-6.24a.938.938 0 0 1 0-1.875h3.979L21.63 8.369a9.33 9.33 0 0 0-4.204-2.426 9.375 9.375 0 0 0-11.482 6.63.938.938 0 0 1-1.811-.486Zm21.07 4.675c.5.134.797.648.663 1.149-1.608 6.001-7.777 9.563-13.778 7.954a11.201 11.201 0 0 1-5.045-2.91l-2.376-2.377v3.976a.937.937 0 1 1-1.875 0v-6.24c0-.518.42-.938.938-.938h6.24a.938.938 0 0 1 0 1.875H5.993l2.377 2.378a9.33 9.33 0 0 0 4.204 2.425 9.375 9.375 0 0 0 11.482-6.629.938.938 0 0 1 1.148-.663Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowCircle;